import styles from './Loader.module.css';

export default function Loader() {
  return (
    <div className={styles.loader}>
      <span className={`material-symbols-rounded spin ${styles.icone}`}>progress_activity</span>
    </div>
  );
}

